import { render } from "./InfoPanel.vue?vue&type=template&id=1ab4e88a"
import script from "./InfoPanel.vue?vue&type=script&lang=js"
export * from "./InfoPanel.vue?vue&type=script&lang=js"

import "./InfoPanel.vue?vue&type=style&index=0&id=1ab4e88a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__